import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ApiGatewayHelperService }from './apigateway-helper.service';
import { LoaderService } from './loader.service';


import Raven from 'raven-js';
import { map } from 'rxjs/operators';
import { appSetting } from 'config/appSettings';
import { AppHelperService } from './app-helper.service';
import { ThemeService } from "libs-frontend-micro-base";
import { GigyaSessionService } from './gigya-session.service';
import { UserDataService } from './user-data.service';


@Injectable()
export class AuthService {
    isUserAuthenticationChecked = false;
    logoutTriggered = new EventEmitter<string>();
    logoutExpress = false;
    userAuthenticatedDataSource: string;
    isGigyaLoaded = false;
    rurl : string;
    constructor(
        private http: HttpClient,
        private apiGatewayHelperService : ApiGatewayHelperService,
        private loaderService: LoaderService,
        private appHelperService: AppHelperService,
        private gigyaSessionService: GigyaSessionService,
        private userDataService: UserDataService
    ) { }

    logOut() : Observable<any> {
        Raven.setUserContext();
        this.loaderService.showOverlayLoader();
        return this.http.post(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + 'logout', {}).pipe(
            map((res: any) => {
                // Remove existing user data in Session Storage
                sessionStorage.removeItem(appSetting.sessionStorage.userAccount);
                if (res.success) {
                    setTimeout(() => { localStorage.setItem(appSetting.localStorage.userLoggedOut, 'true'); }, 500);
                }
                var themeService = new ThemeService();
                themeService.resetThemeToDefault();
                return res;
            })
        );
    }

    loginWithExistingGigyaSession(loggedInUserData) : Observable<any> {
        return this.http.post(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + 'login', loggedInUserData);
    }

    isUserAuthenticated() {
        const userData = sessionStorage.getItem(appSetting.sessionStorage.userAccount);
        if(userData) {
            this.userAuthenticatedDataSource = 'sessionStorage';
            return of({
                userAuthenticated: true,
                user: JSON.parse(userData)
            });
        } else {
            return this.http.get(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + 'isUserAuthenticated');
        }
    }
    setUserData(user) {
        this.userDataService.setUserData(user)
    }
    getUserData() {
        return this.userDataService.getUserData();
    }
    // cleans userData
    clearUserdata(){
        this.isUserAuthenticationChecked = false;
        this.userDataService.setUserData(false)
    }
    // for routes that must require a definite value of userdata like my-profile
    // prepopulate userData
    resolve(){
        return this.isUserAuthenticated().toPromise().then((res:any)=> {
                this.isUserAuthenticationChecked = true;
                if(res.userAuthenticated) {
                    this.setUserData(res.user);
                    return this.getUserData();
                } else {
                    return true;
                }
            });  
    }

    expressLogoutAndRedirect() {
        if( this.isUserAuthenticationChecked  && this.getUserData()) {
            this.logOut().toPromise().then(() => {
                // On Logout navigate to home page
                this.appHelperService.navigateToOnboardingApp(['home'], { forceExit: true });
            });
        }
    }
    checkGigyaAndServerSession(){
        //Both guard and appcomponent are calling this function and setting 1 variable each in this service
        //When both variables are true then logoutGigyaOrExpressServer funtion is called to check both sessions. 
        return new Promise(async(resolve, reject)=> {
            //Check the server session and gigya session only if gigya is loaded and user authentication is checked
            if(this.isUserAuthenticationChecked && this.isGigyaLoaded) {
                const gigyaData = await this.gigyaSessionService.getUserData()
                this.logoutGigyaOrExpressServer(gigyaData, this.userDataService.getUserData());
                resolve(true);
            } else { //Continue the calling function if any of gigya or server session is not yet loaded/checked 
                resolve(true);
            }
        })

    }

    async getUserDataFromSession() {
        if(!this.isUserAuthenticationChecked) {
            const res:any = await this.isUserAuthenticated().toPromise();
            this.isUserAuthenticationChecked = true;
            if(res.userAuthenticated) {
                this.setUserData(res.user);
                sessionStorage.setItem(appSetting.sessionStorage.userAccount, JSON.stringify(res.user));
            }
        }
        return this.getUserData();
    }
    private logoutGigyaOrExpressServer(gigyaSessionExists, serverSessionExists) {
        if (gigyaSessionExists && serverSessionExists) {
            if(gigyaSessionExists.UID == serverSessionExists.extUserId) return true;
            else {
                this.logOut().toPromise().then(() => {
                    return this.gigyaSessionService.gigyaLogout();                  
                }).then(()=> {
                    this.navigateToRurl();
                });
            }

        } else if (!gigyaSessionExists && serverSessionExists) {
            //end backend session and navigate to home page
            this.logOut().toPromise().then(() => {
                // On Logout navigate to home page
                this.navigateToRurl();

            });
        } else if (gigyaSessionExists && !serverSessionExists) {
            /**
            * This is to handle the case when user is logged out from backend but gigya session still exists
            */

            this.gigyaSessionService.getUserData().then((userData) => {
                this.loginWithExistingGigyaSession(userData).toPromise().then((res) => {
                    return true;
                });
            });
        } else {
            this.navigateToRurl();
        }
    }

    navigateToRurl() {
        //Navigate to Home if user is unauthenticated
        if(this.rurl) {
            this.appHelperService.navigateToOnboardingApp(['login'], { queryParams : { rurl : encodeURIComponent(this.rurl) }, forceExit: true });
        } else {
            this.appHelperService.navigateToOnboardingApp(['login'], { forceExit: true });
        }
    }
}